(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nc-range-filter"] && !Shopify.designMode) return;
  try {
    (function() {
    function initRange(root) {
      if (root.dataset.ncRangeInit) return;
      root.dataset.ncRangeInit = '1';

      var paramName = root.dataset.param || '';
      var rangeMin = parseFloat(root.dataset.rangeMin) || 0;
      var rangeMax = parseFloat(root.dataset.rangeMax) || 0;
      var countOne = root.dataset.countOne || '1';
      var countOther = root.dataset.countOther || '99999';
      var thumbMin = root.querySelector('[data-nc-range-thumb="min"]');
      var thumbMax = root.querySelector('[data-nc-range-thumb="max"]');
      var inputMin = root.querySelector('[data-nc-range-input="min"]');
      var inputMax = root.querySelector('[data-nc-range-input="max"]');
      var fill     = root.querySelector('[data-nc-range-fill]');
      var histo    = root.querySelector('[data-nc-range-histogram]');
      var countEl  = root.querySelector('[data-nc-range-count]');
      if (!thumbMin || !thumbMax || !fill) return;

      var bars = histo ? Array.prototype.slice.call(histo.querySelectorAll('.nc-range__bar')) : [];

      function formatCount(n) {
        if (n === 1) return countOne;
        return countOther.replace('[COUNT]', n);
      }

      function updateCount() {
        if (!countEl || !bars.length) return;
        var total = 0;
        var active = 0;
        var hasActive = false;
        bars.forEach(function(b) {
          var c = parseFloat(b.getAttribute('data-count')) || 0;
          total += c;
          if (b.getAttribute('data-active') === 'true') {
            active += c;
            hasActive = true;
          }
        });
        var value = hasActive ? active : total;
        countEl.textContent = formatCount(value);
        var mn = parseFloat(thumbMin.value);
        var mx = parseFloat(thumbMax.value);
        var isDefault = (mn === rangeMin && mx === rangeMax);
        if (isDefault) {
          countEl.removeAttribute('data-has-filter');
        } else {
          countEl.setAttribute('data-has-filter', 'true');
        }
      }

      function layoutBars() {
        if (!bars.length) return;
        var counts = bars.map(function(b) {
          return parseFloat(b.getAttribute('data-count')) || 0;
        });
        var maxCount = Math.max.apply(null, counts);
        if (maxCount > 0) {
          bars.forEach(function(b, i) {
            var pct = (counts[i] / maxCount) * 100;
            b.style.height = Math.max(pct, 6) + '%';
          });
        } else {
          bars.forEach(function(b) { b.style.height = '6%'; });
        }
      }

      function updateFill() {
        var mn = parseFloat(thumbMin.value);
        var mx = parseFloat(thumbMax.value);
        if (isNaN(mn)) mn = rangeMin;
        if (isNaN(mx)) mx = rangeMax;
        if (mn > mx) { var t = mn; mn = mx; mx = t; }
        var span = rangeMax - rangeMin;
        var pctMin = span > 0 ? ((mn - rangeMin) / span) * 100 : 0;
        var pctMax = span > 0 ? ((mx - rangeMin) / span) * 100 : 100;
        fill.style.left  = pctMin + '%';
        fill.style.width = (pctMax - pctMin) + '%';

        if (bars.length) {
          var nb = bars.length;
          var minIdx = Math.floor((pctMin / 100) * nb);
          var maxIdx = Math.ceil((pctMax / 100) * nb);
          bars.forEach(function(b, i) {
            if (i >= minIdx && i < maxIdx) {
              b.setAttribute('data-active', 'true');
            } else {
              b.removeAttribute('data-active');
            }
          });
        }

        updateCount();
      }

      function emitChange() {
        var mn = parseFloat(thumbMin.value);
        var mx = parseFloat(thumbMax.value);
        if (isNaN(mn)) mn = rangeMin;
        if (isNaN(mx)) mx = rangeMax;
        if (mn > mx) { var t = mn; mn = mx; mx = t; }
        var isDefault = (mn === rangeMin && mx === rangeMax);
        root.dispatchEvent(new CustomEvent('nc:range:change', {
          bubbles: true,
          detail: {
            paramName: paramName,
            min: isDefault ? null : mn,
            max: isDefault ? null : mx
          }
        }));
      }

      function onThumbInput(e) {
        var mn = parseFloat(thumbMin.value);
        var mx = parseFloat(thumbMax.value);
        if (mn > mx) {
          if (e.target === thumbMin) thumbMin.value = mx;
          else thumbMax.value = mn;
        }
        inputMin.value = thumbMin.value;
        inputMax.value = thumbMax.value;
        updateFill();
      }

      function onNumberInput(e) {
        var v = parseFloat(e.target.value);
        if (isNaN(v)) return;
        if (v < rangeMin) v = rangeMin;
        if (v > rangeMax) v = rangeMax;
        if (e.target === inputMin) thumbMin.value = v;
        else thumbMax.value = v;
        updateFill();
      }

      thumbMin.addEventListener('input', onThumbInput);
      thumbMax.addEventListener('input', onThumbInput);
      thumbMin.addEventListener('change', emitChange);
      thumbMax.addEventListener('change', emitChange);
      inputMin.addEventListener('input', onNumberInput);
      inputMax.addEventListener('input', onNumberInput);
      inputMin.addEventListener('change', emitChange);
      inputMax.addEventListener('change', emitChange);

      root.ncRangeAPI = {
        setBuckets: function(counts) {
          if (!bars.length) return;
          bars.forEach(function(b, i) {
            var c = parseFloat(counts[i]) || 0;
            b.setAttribute('data-count', c);
            b.setAttribute('title', formatCount(c));
          });
          layoutBars();
          updateFill();
        },
        reset: function() {
          thumbMin.value = rangeMin;
          thumbMax.value = rangeMax;
          inputMin.value = '';
          inputMax.value = '';
          updateFill();
        },
        setRange: function(mn, mx) {
          thumbMin.value = (mn == null || isNaN(mn)) ? rangeMin : mn;
          thumbMax.value = (mx == null || isNaN(mx)) ? rangeMax : mx;
          inputMin.value = (mn == null || isNaN(mn)) ? '' : mn;
          inputMax.value = (mx == null || isNaN(mx)) ? '' : mx;
          updateFill();
        }
      };

      layoutBars();
      updateFill();
    }

    function initAll() {
      document.querySelectorAll('[data-nc-range]').forEach(initRange);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
